import { render } from "./CRMStatusIndicator.vue?vue&type=template&id=909e70a2&scoped=true"
import script from "./CRMStatusIndicator.vue?vue&type=script&lang=js"
export * from "./CRMStatusIndicator.vue?vue&type=script&lang=js"

import "./CRMStatusIndicator.vue?vue&type=style&index=0&id=909e70a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-909e70a2"]])

export default __exports__